import React from "react";
import { useParams } from "react-router-dom";
import SectionTitle from "../../components/section-title";
import Widget from "../../components/widget";
import BlogForm from "../../components/blog/BlogForm";

const BlogEdit = () => {
  const { id } = useParams();

  return (
    <>
      <SectionTitle title="Edit Blog" subtitle="Blogs" />
      <Widget>
        <BlogForm mode="edit" blogId={id} />
      </Widget>
    </>
  );
};

export default BlogEdit;
